
import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import {
    useParams
} from "react-router-dom";
import '../assets/css/RadioDesign.css'


import ProgressBar from '../components/ProgressBar.js'
import convert from '../Helper/NumberToWord'
import Loading from '../Helper/Loading.js'
import { apiCall } from '../Service/ConnectToServer.js';
import Swal from 'sweetalert2'
import CheckVarizId from '../Helper/CheckVarizId.js'
import { ComponentToPrint } from './PayResultPrint'
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    FormGroup,
    Input,
    Modal
} from "reactstrap";

const changeNumber = (num) => {
    console.log(num)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
const print = () => {
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');


    mywindow.document.write(document.getElementById("print").outerHTML);


    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
}

function Payment() {

    let { Code, ResNum } = useParams();
    const [current] = React.useState(4);
    const [PaymentResult, setPaymentResult] = React.useState({});
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });


    React.useEffect(() => {
        if (Code === "Ok") {
            const config = {
                method: "Post",
                url: "Payment/GetPaymentByResNum",
                Authorization: true,
                data: { Id: ResNum }
            }
            apiCall(config, (response) => {
                setPaymentResult(response.data.Result)
            }, (err) => {
                console.log(err)
                Swal.fire({
                    title: 'عملیات ناموفق',
                    text: err,
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
            });
        }
    }, []);


    return (
        <>
            <div className="content text-right">
                <Row>
                    <Col xs="12">
                        <Card className="card-chart">
                            <CardBody>
                                <ProgressBar current={current} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Col md="3"></Col>
                <Col md="6">
                    {Code === "Ok" ?
                        <ComponentToPrint Result={PaymentResult} ref={componentRef} handlePrint={()=>handlePrint()} />
                        :
                        <Card className="card-info">
                            <CardHeader style={{ textAlign: "center", backgroundColor: "crimson", padding: "20px" }}>
                                <strong style={{ fontSize: "20px", color: "white" }}>نتیجه پرداخت اینترنتی</strong>
                            </CardHeader>
                            <CardBody style={{ textAlign: "center" }}>
                                <img style={{ width: "100px", height: "100px" }} src={require("../assets/img/cancel.png").default} alt="MelatImage"></img>
                                <p style={{ fontSize: "20px", color: "red" }}>پرداخت ناموفق</p>
                                <Col style={{ marginTop: "30px" }}>
                                    <p>در صورت کسر وجه از حساب شما ، مبلغ پرداختی حداکثر تا 72 ساعت بعد به حساب شما برگشت داده می شود</p>
                                </Col>
                            </CardBody>
                        </Card>

                    }
                </Col>
                <Col md="3"></Col>


            </div>
        </>
    );
}




export default Payment;
